import { o as a } from "../../../nexus-client-4D0Jw00_.js";
const o = a.promo.combo.presentation, t = o.imageChange, e = o.variationChange;
export {
  t as imageChange,
  o as promoComboPresentation,
  e as variationChange
};
/*                             */
